import { css } from 'goober';
import React, { memo, useCallback } from 'react';
import State from '../../state';
import { hasYoutubeVideo } from '../../utils/common';
import StoryProgress from '../StoryProgress';
const Stories = css `
  display: flex;
  margin: 0 8px;
  justify-content: stretch;
  pointer-events: none;
`;
const GlanceHighlights = (props) => {
    const { highlights = [], highlightIndex, index, glanceIndex, changeGlanceIndex, changeHighlightIndex, isAutoPlayPaused = true, hasAudio, isHolding, } = props;
    const onEnd = useCallback(() => {
        if (highlightIndex >= highlights.length - 1) {
            const { totalGlances } = State;
            if (glanceIndex + 1 < totalGlances) {
                changeGlanceIndex(glanceIndex + 1);
            }
        }
        else {
            changeHighlightIndex(highlightIndex + 1);
        }
    }, [
        highlightIndex,
        highlights.length,
        glanceIndex,
        changeGlanceIndex,
        changeHighlightIndex,
    ]);
    if (highlights.length === 0)
        return null;
    return (React.createElement("div", { className: Stories }, highlights.map((story, i) => {
        const isYoutubeVideo = hasYoutubeVideo(story);
        return (React.createElement(StoryProgress, { hasAudio: hasAudio, key: story.glanceId, onEnd: onEnd, glanceId: story.glanceId, isHolding: isHolding, isAutoPlayPaused: isAutoPlayPaused, glanceIndex: glanceIndex, storyIndex: i, cardIndex: index, isYoutube: isYoutubeVideo, highlightIndex: highlightIndex }));
    })));
};
const checkProps = (prevProps, nextProps) => {
    return !(prevProps.index === prevProps.glanceIndex ||
        nextProps.glanceIndex === nextProps.index);
};
export default memo(GlanceHighlights, checkProps);
//# sourceMappingURL=index.js.map